import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { UserInfo } from 'firebase';

import { AuthenticationService } from 'src/app/auth/fire-auth/authentication.service';
import { UserfirestoreService } from 'src/app/auth/fire-store/userfirestore.service';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { Status } from './../../constants';
import { User } from 'src/app/models/user';

@Component({
  selector: 'makaw-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
})
export class EditProfileComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject();
  public currentUser: User;
  public status = Status.Edit;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly userService: UserfirestoreService
  ) {}

  ngOnInit() {
    this.authenticationService
      .getStatus()
      .pipe(
        switchMap((status: UserInfo) =>
          this.userService.getUserById(status.uid).valueChanges()
        ),
        tap((currentUser: User) => (this.currentUser = currentUser)),
        takeUntil(this.destroyed$)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
